export const businessUnits = ['GatewayDigital', 'AutoFacets', 'AutoDAP', 'DiLX', 'GSecure-Labs', 'TecBridge'];
